import { consumeHandoffIntoContext, } from "@next-platform/packages-ts-types";
import { getAttributionHost } from "./attributionHost";
import { readAttributionContext, writeAttributionContext, } from "./attributionStorage";
/**
 * Thin IO wrapper around the pure `consumeHandoffIntoContext` reducer:
 * reads the persisted envelope, passes the host's verifier, and
 * persists the merged result. Returns `undefined` when the input is
 * malformed, wrong version, or too large.
 */
export async function consumeAttributionHandoffParam(encoded) {
    const host = getAttributionHost();
    const existing = await readAttributionContext();
    const result = await consumeHandoffIntoContext(existing, encoded, {
        verifier: host.verifier,
    });
    if (result === undefined) {
        return undefined;
    }
    await writeAttributionContext(result.next);
    return {
        context: result.next,
        isSignatureVerified: result.isSignatureVerified,
    };
}
